import classNames from 'classnames';
import { useEffect, useRef } from 'react';
import Bar from '../../components/Bar/Bar';
import Portal from '../../components/Portal/Portal';
import Transition from '../../components/Transition/Transition';
import Justify from '../../types/enum/Justify';
import Position from '../../types/enum/Position';
import Size from '../../types/enum/Size';
import Theme from '../../types/enum/Theme';

import './Toast.scss';
import IToastProps from './ToastProps';

const Toast = (props: IToastProps) => {
  const { isOpen, speedIn, speedOut, theme, position, justify, onClose, timeout, children, className } = props;

  const timeoutRef = useRef<NodeJS.Timeout | null>();
  const prevProps = useRef<IToastProps>(props);

  useEffect(() => {
    if (timeout > 0) {
      if (!prevProps.current.isOpen && props.isOpen) {
        setTimeoutRef();
      } else if (prevProps.current.isOpen && !props.isOpen && timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }

      prevProps.current = props;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  function setTimeoutRef() {
    if (onClose) {
      timeoutRef.current = setTimeout(() => {
        onClose();
      }, timeout);
    }
  }

  const classes = classNames(
    'toast',
    {
      [`toast-position-${position}`]: true,
      [`toast-${theme}`]: true,
    },
    className
  );

  return (
    <Portal>
      <Transition isOpen={isOpen} transitionName={`toast-${position}-anim`} speedIn={speedIn} speedOut={speedOut}>
        <Bar size={Size.SMALL} justify={justify} className={classes}>
          {children}
        </Bar>
      </Transition>
    </Portal>
  );
};

Toast.defaultProps = {
  timeout: 3000,
  position: Position.BOTTOM,
  speedIn: 500,
  speedOut: 250,
  theme: Theme.DARK,
  justify: Justify.CENTER,
};

export default Toast;
